"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const accordionItemInputs = [
  {
    name: "title",
    type: "string",
    defaultValue: "Accordion Item",
    required: true,
  },
  {
    name: "id",
    type: "string",
    defaultValue: "accordion-item",
    required: true,
  },
] as const satisfies Inputs;

export const AccordionItemComponent: RegisteredComponent = {
  name: "AccordionItem",
  component: withValidation(
    accordionItemInputs,
    dynamic(() => import("./AccordionItem").then((mod) => mod.AccordionItem)),
    "AccordionItem"
  ),
  canHaveChildren: true,
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "LinksList",
        options: {
          style: "blue-links",
          listClickEvent: "list_click",
          listItems: [
            {
              title: "First link",
              path: "/",
              tabBehaviour: "sameTab",
            },
            {
              title: "Second link",
              path: "/",
              tabBehaviour: "sameTab",
            },
            {
              title: "Third link",
              path: "/",
              tabBehaviour: "sameTab",
            },
          ],
        },
      },
    },
  ],
  inputs: accordionItemInputs,
};
